import axios from "axios";
import _ from "lodash";
import { sisikong_url } from "../..";
import type { HotelAutocompleteRS } from "./types";

export async function accommodationAutocomplete({
  name,
  source_entity,
  website_api_key,
}: {
  name: string;
  source_entity?: string;
  website_api_key?: string;
}): Promise<HotelAutocompleteRS | null> {
  const query = name
    .replace(/-/g, " ")
    .split(" ")
    .map((s) => _.trim(s))
    .join(" ");

  const params: { name: string; source_entity?: string; website_api_key?: string } = {
    name: query,
  };
  if (source_entity) params.source_entity = source_entity;
  if (website_api_key) params.website_api_key = website_api_key;

  try {
    const response = await axios.get(`${sisikong_url}/accommodator/api/autocomplete/`, {
      params,
    });
    return response.data;
  } catch {
    return null;
  }
}
